import Vuex from 'vuex';
import Vue from 'vue';
import mutationType from '@/store/mutation-types';
import Profile from '@/model/common/profile';

// import _collection from 'lodash/collection';

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		profile: new Profile(),
		message: null,
		token: null,
		// bindContract: [],
		// unBindContract: [],
		routePath: null,
		breadCrumb: null
	},
	getters: {
		getRoutePath: state => state.routePath,
		getServiceType: state => state.serviceType,
		getAccountPayModel: state => state.accountPayModel,
		getUserTxLogModel: state => state.userTxLogModel,
	},
	mutations: {
		[mutationType.profile]: (state, payload) => {
			state.profile = payload;
		},
		[mutationType.message]: (state, payload) => {
			state.message = payload;
		},
		// [mutationType.contract]: (state, payload) => {
		//   state.bindContract = _collection.filter(payload, contract => contract.isBind === true);
		//   state.unBindContract = _collection.filter(payload, contract => contract.isBind === false);
		// },
		[mutationType.routePath]: (state, payload) => {
			state.routePath = payload;
		},
        [mutationType.breadCrumb]: (state, payload) => {
            state.breadCrumb = payload;
		}
	},
});



// WEBPACK FOOTER //
// ./src/store/store.js